var PromiseDelegate = (function () {
    function PromiseDelegate(ignoreMultipleSettles) {
        var _this = this;
        if (ignoreMultipleSettles === void 0) { ignoreMultipleSettles = false; }
        this.ignoreMultipleSettles = ignoreMultipleSettles;
        this.isSettled = false;
        this.promise = new Promise(function (resolve, reject) {
            _this.resolveCallback = resolve;
            _this.rejectCallback = reject;
        });
    }
    PromiseDelegate.prototype.markAsSettled = function () {
        var wasSettled = this.isSettled;
        if (wasSettled && !this.ignoreMultipleSettles) {
            throw new Error("PromiseDelegate is already settled!");
        }
        this.isSettled = true;
        return !wasSettled;
    };
    Object.defineProperty(PromiseDelegate.prototype, "settled", {
        get: function () {
            return this.isSettled;
        },
        enumerable: false,
        configurable: true
    });
    PromiseDelegate.prototype.resolve = function (value) {
        if (this.markAsSettled()) {
            this.resolveCallback(value);
        }
    };
    PromiseDelegate.prototype.reject = function (reason) {
        if (this.markAsSettled()) {
            this.rejectCallback(reason);
        }
    };
    return PromiseDelegate;
}());
export { PromiseDelegate };
//# sourceMappingURL=PromiseDelegate.js.map